/**
 * Font-size utility passed by the caller (e.g. font-mono text-xs); colour utilities like text-text-primary do not match.
 * Field primitives (Input, Textarea, SearchInput) drop their default font size when the caller passes one.
 */
export const CALLER_FONT_SIZE = /(^|\s)text-(xs|sm|base|lg|xl|\d?xl|\[[^\]]+\])(\s|$)/;
